module.exports = __webpack_public_path__ + "static/media/ward-icon.f8dac068.svg";